import React from "react";
import { Grid } from "@mui/material";
import "./MarketingClaims.css";
import customer from "../../../Assets/footer-customer-icon.svg";
import madeInInida from "../../../Assets/footer-made-in-india-icon.svg";
import assuredQuality from "../../../Assets/footer-quality-icon.svg";
import securePayment from "../../../Assets/footer-secure-payment-icon.svg";

const MarketingClaims = () => {
  const itemStyles = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    // width: 30,
    // height: 30
    margin : 0,
    padding: 1,
    
  };
  return (
    <Grid container className="border-t p-11 items-center">
      <Grid item md={3} xs={6} sx={{
        ...itemStyles,
        marginTop: "1rem"
      }}>
        <img src={madeInInida} />
        <p className="text-center mt-5">MADE IN INDIA</p>
      </Grid>
      <Grid item xs={6} md={3} sx={itemStyles}>
        <img src={securePayment} />
        <p className="text-center  mt-4">ASSURED QUALITY</p>
      </Grid>
      <Grid item md={3} xs={6} sx={itemStyles}>
        <img src={assuredQuality} />
        <p className="text-center mt-4">SECURE PAYMENTS</p>
      </Grid>
      <Grid item md={3} xs={6} sx={{
        ...itemStyles,
        marginTop: '0.3rem'
      }}>
        <img src={customer} />
        <p className="text-center mt-6">EMPOWERING WEAVERS</p>
      </Grid>
    </Grid>
  );
};

export default MarketingClaims;
